module.exports = __webpack_public_path__ + "static/img/product_three.3c2556f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_three.png
// module id = i1kJ
// module chunks = 1